import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function Signup({ onSwitch }) {
  const [form, setForm] = useState({ name:'', email:'', phone:'', password:'', confirm:'' });
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState('');
  const [loading, setLoading] = useState(false);
  const { signup } = useAuth();
  const navigate = useNavigate();
  const upd = f => e => setForm(p => ({ ...p, [f]: e.target.value }));

  function validate() {
    const e = {};
    if (!form.name.trim()) e.name = 'Full name is required';
    if (!form.email.trim()) e.email = 'Email is required';
    if (!form.phone.trim() || form.phone.replace(/\D/g,'').length < 10) e.phone = 'Valid phone number required';
    if (!form.password || form.password.length < 6) e.password = 'Minimum 6 characters';
    if (form.password !== form.confirm) e.confirm = 'Passwords do not match';
    return e;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const errs = validate(); setErrors(errs);
    if (Object.keys(errs).length) return;
    try {
      setApiError(''); setLoading(true);
      await signup(form.email, form.password, form.name, form.phone);
      navigate('/dashboard');
    } catch (err) {
      if (err.code==='auth/email-already-in-use') setApiError('An account with this email already exists.');
      else if (err.code==='auth/invalid-email') setApiError('Please enter a valid email address.');
      else if (err.code==='auth/weak-password') setApiError('Password is too weak. Use at least 6 characters.');
      else setApiError('Account creation failed. Please try again.');
    } finally { setLoading(false); }
  }

  return (
    <div className="auth-wrapper">
      <div className="auth-panel-left">
        <div className="left-logo">
          <div className="left-logo-icon">L</div>
          <span className="left-logo-name">Lend Pesa</span>
        </div>
        <h2 className="left-headline">Your Loan,<br />Your Terms.</h2>
        <p className="left-sub">Join thousands of Kenyans who trust Lend Pesa for fast, flexible loans.</p>
        <div className="left-stats">
          {[
            { icon:'💰', text:'Up to Ksh 48,600',  sub:'Flexible loan amounts available' },
            { icon:'⏱️', text:'2-Month Terms',      sub:'Short-term, manageable repayments' },
            { icon:'📊', text:'10% Interest Only',  sub:'Fair and transparent pricing' },
            { icon:'🚀', text:'100% Online',         sub:'No branch visit needed' },
          ].map(s => (
            <div className="stat-pill" key={s.text}>
              <div className="stat-pill-icon">{s.icon}</div>
              <div>
                <div className="stat-pill-text">{s.text}</div>
                <div className="stat-pill-sub">{s.sub}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="auth-panel-right">
        <div className="auth-form-wrap">
          <div className="auth-form-logo">
            <div className="auth-form-logo-icon">L</div>
            <span className="auth-form-logo-name">Lend Pesa</span>
          </div>
          <h2 className="auth-form-title">Create Account 🚀</h2>
          <p className="auth-form-sub">Start your application in under 2 minutes</p>

          {apiError && <div className="alert-err"><span>⚠️</span>{apiError}</div>}

          <form onSubmit={handleSubmit}>
            {[
              { f:'name',    label:'Full Name',              type:'text',     ph:'John Kamau' },
              { f:'email',   label:'Email Address',          type:'email',    ph:'john@example.com' },
              { f:'phone',   label:'Phone Number (M-Pesa)',  type:'tel',      ph:'0712 345 678' },
              { f:'password',label:'Password',               type:'password', ph:'Minimum 6 characters' },
              { f:'confirm', label:'Confirm Password',       type:'password', ph:'Repeat your password' },
            ].map(({ f, label, type, ph }) => (
              <div className="field-group" key={f}>
                <label className="field-label">{label}</label>
                <input type={type} className={`field-input${errors[f]?' err':''}`}
                  placeholder={ph} value={form[f]} onChange={upd(f)} />
                {errors[f] && <p className="field-error">{errors[f]}</p>}
              </div>
            ))}
            <button type="submit" className="btn-submit" disabled={loading}>
              {loading ? <><span className="mini-spin"></span>Creating account…</> : 'Create Account →'}
            </button>
          </form>

          <div className="auth-switch">Already have an account? <a onClick={onSwitch}>Sign in</a></div>
          <div className="trust-chips">
            <span className="trust-chip">🔒 256-bit SSL</span>
            <span className="trust-chip">✅ No CRB Check</span>
            <span className="trust-chip">⚡ Instant Approval</span>
          </div>
        </div>
      </div>
    </div>
  );
}
